(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/slicedToArray", "@babel/runtime/helpers/defineProperty", "./loading.less", "../_style/images/inlineLoadingGif", "../button"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/slicedToArray"), require("@babel/runtime/helpers/defineProperty"), require("./loading.less"), require("../_style/images/inlineLoadingGif"), require("../button"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.slicedToArray, global.defineProperty, global.loading, global.inlineLoadingGif, global.button);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _slicedToArray2, _defineProperty2, _loading, _inlineLoadingGif, _button) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _slicedToArray2 = _interopRequireDefault(_slicedToArray2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _button = _interopRequireDefault(_button);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isLoadingWrapShow,
          expression: "isLoadingWrapShow"
        }],
        staticClass: "nx-loading",
        class: [{
          'nx-loading-fullscreen': _vm.fullscreen,
          'nx-loading-light': _vm.theme === 'light'
        }]
      }, [_c('transition', {
        attrs: {
          "name": _vm.location === 'bottom' ? 'nx-fade' : ''
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.hasMask && _vm.isLoadingShow,
          expression: "hasMask && isLoadingShow"
        }],
        staticClass: "nx-loading-mask",
        class: {
          'nx-loading-transparent': _vm.isMaskTransparent
        }
      })]), _c('transition', {
        attrs: {
          "name": _vm.location === 'bottom' && !!_vm.btn ? 'nx-loading-slide-up-btn' : _vm.location === 'bottom' ? 'nx-loading-slide-up' : ''
        },
        on: {
          "after-leave": _vm.$_onTransitionEnd
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isLoadingShow,
          expression: "isLoadingShow"
        }],
        staticClass: "nx-loading-toast",
        class: ["nx-loading-location-" + _vm.location, {
          'nx-loading-btn-bottom': !!_vm.btn
        }]
      }, [_c('div', {
        staticClass: "loading-content"
      }, [_c('img', {
        staticClass: "loading-logo",
        attrs: {
          "src": _vm.logoPic,
          "alt": ""
        }
      }), _vm.cutDown ? _vm._t("default", [_c('span', [_vm._v(" " + _vm._s(_vm.content) + " ")])]) : _vm._t("default", [_vm._v("正在加载")])], 2), _vm.btn ? _c('div', {
        staticClass: "nx-loading-actions"
      }, [_c('nx-button', {
        staticClass: "nx-loading-btn",
        class: {
          warning: !_vm.btn.disabled && !!_vm.btn.warning
        },
        style: Object.assign({}, {
          color: _vm.btn.color || ''
        }, _vm.btn.styles),
        attrs: {
          "type": _vm.btn.type || 'link',
          "disabled": _vm.btn.disabled,
          "round": "",
          "tagProps": _vm.btn.tagProps,
          "aria-hidden": _vm.btn.ariaHidden
        },
        on: {
          "click": function click($event) {
            return _vm.$_onClick(_vm.btn);
          },
          "touchmove": function touchmove($event) {
            $event.preventDefault();
          }
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.btn.text))])])], 1) : _vm._e()])])], 1);
    },
    name: 'nx-loading',
    props: {
      show: Boolean,
      // 幕布 true: 会阻止用户点击
      hasMask: {
        type: Boolean,
        default: false
      },
      // 幕布颜色 transparent
      isMaskTransparent: {
        type: Boolean,
        default: false
      },
      // 全屏
      fullscreen: {
        type: Boolean,
        default: false
      },
      // 是否展示白底 light：无白底
      theme: {
        type: String,
        default: 'dark'
      },
      // 是否开启倒计时5s
      cutDown: {
        type: Boolean,
        default: false
      },
      // 倒计时时间
      time: {
        type: Array,
        default: function _default() {
          return [5, 1000, 's'];
        }
      },
      // 开始倒计时文案
      startContent: {
        type: String,
        default: '正在加载'
      },
      // 结束倒计时文案
      finallyContent: {
        type: String,
        default: '加载完成'
      },
      // 自定义loading动图
      loadingLogo: {
        type: String,
        default: undefined
      },
      location: {
        type: String,
        default: 'bottom' // loading弹窗位置-center、bottom，os4.0规范是在底部

      },
      appendTo: undefined,
      maskClosable: {
        type: Boolean,
        default: false
      },
      btn: {
        type: Object
      }
    },
    data: function data() {
      return {
        content: '',
        timer: null,
        // 定时器
        isLoadingWrapShow: this.show,
        isLoadingShow: false
      };
    },
    components: (0, _defineProperty2.default)({}, _button.default.name, _button.default),
    watch: {
      show: function show(newVal, oldVal) {
        if (newVal) this.$_showLoadingBox();else this.$_hideLoadingBox();

        if (newVal && this.cutDown) {
          this.startTimer();
        } else if (oldVal) {
          this.clear();
        }
      }
    },
    model: {
      prop: 'show'
    },
    created: function created() {
      // 提前加载loading动效
      var i = new Image();
      i.src = _inlineLoadingGif.inlineLoadingGifS;
      if (this.show) this.$_showLoadingBox();else this.$_hideLoadingBox();
    },
    computed: {
      logoPic: function logoPic() {
        return this.loadingLogo || _inlineLoadingGif.inlineLoadingGifS;
      }
    },
    mounted: function mounted() {
      if (this.appendTo) {
        this.appendTo.appendChild(this.$el);
      }
    },
    methods: {
      startTimer: function startTimer() {
        var _this = this;

        var _this$time = (0, _slicedToArray2.default)(this.time, 3),
            _time = _this$time[0],
            interval = _this$time[1],
            unit = _this$time[2];

        this.content = this.startContent + _time + unit;
        this.timer = setInterval(function () {
          _time--;
          _this.content = _this.startContent + _time + unit;

          if (_time === 0) {
            _this.content = _this.finallyContent;
            clearInterval(_this.timer);
          }
        }, interval);
      },
      clear: function clear() {
        this.timer && clearInterval(this.timer);
      },
      $_showLoadingBox: function $_showLoadingBox() {
        this.isLoadingWrapShow = true;
        this.isLoadingShow = true;
      },
      $_hideLoadingBox: function $_hideLoadingBox() {
        this.isLoadingShow = false;
        this.$emit('input', false);
      },
      $_onTransitionEnd: function $_onTransitionEnd() {
        if (!this.isLoadingShow) {
          this.isLoadingWrapShow = false;
        }
      },
      $_onClick: function $_onClick(btn) {
        if (btn.disabled || btn.loading) {
          return;
        }

        if (typeof btn.handler === 'function') {
          btn.handler.call(null, btn);
        } else {
          this.clear();
          this.$_hideLoadingBox();
        }
      }
    }
  };
  _exports.default = _default2;
});